<template>
  <div id="app" :style="isContactsPage ? 'background-color: #F6F6F6;' : ''">
    <Navbar v-if="isNavbarOpen" @close="toggleNavbar" />
    <div class="sidebar sidebar-top" :class="isHomePage ? '' : 'sidebar-relative'">
      <div class="sidebar-breadcrumbs" v-if="!isHomePage">
        <router-link to="/">
          <img class="logo" src="@/assets/img/Logo_bl.svg" />
        </router-link>
        <ul>
          <li v-for="(crumb, i) in breadcrumbs" :key="i">
            <router-link :to="crumb.to">
              {{ crumb.name }}
              <i class="icon-chevron-right"></i>
            </router-link>
          </li>
          <li>
            <a class="active">
              {{ pageCrumbName }}
            </a>
          </li>
        </ul>
      </div>
      <button @click="toggleNavbar" class="sidebar-burger">
        <i class="icon-menu"></i>
      </button>
    </div>

    <router-view @setLastCrumb="(name) => pageCrumbName = name" />

    <FooterBlock v-if="!isHomePage && !isLoading" />
  </div>
</template>

<script>
import '@/assets/SFPro/fonts.css';
import '@/assets/Circe/fonts.css';
import '@/assets/OpenSans/fonts.css';
import '@/assets/fontello/css/fontello.css';
import '@/assets/css/animation.css';
import '@/assets/sass/app.sass';
import Navbar from '@/components/Navbar.vue';
import FooterBlock from '@/components/FooterBlock.vue';

export default {
  name: 'App',
  components: { Navbar, FooterBlock },
  data() {
    return {
      isLoading: true,
      isNavbarOpen: false,
      isNavbarAnimation: false,
      pageCrumbName: '',
    };
  },
  computed: {
    breadcrumbs() {
      return this.$route.meta.breadcrumbs;
    },
    currentPath() {
      return this.$route.name;
    },
    isHomePage() {
      return this.currentPath === 'Home';
    },
    isContactsPage() {
      return this.currentPath === 'Contacts';
    },
  },
  methods: {
    toggleNavbar() {
      if (!this.isNavbarOpen) {
        this.isNavbarOpen = true;
        return;
      }
      if (this.isNavbarAnimation) return;
      this.closeNavbar();
    },
    closeNavbar() {
      this.isNavbarAnimation = true;
      const navbar = document.querySelector('.navbar');
      const navbarContent = document.querySelector('.navbar-content');
      navbar.style.backgroundColor = 'transparent';
      navbarContent.style.transform = 'translateY(-120%)';
      setTimeout(() => {
        this.isNavbarOpen = false;
        this.isNavbarAnimation = false;
      }, 500);
    },
    loadContacts() {
      this.$store.dispatch('getContacts');
    },
  },
  mounted() {
    this.loadContacts();
    setTimeout(() => {
      this.isLoading = false;
    }, 1000);
  },
};
</script>
